export default __webpack_public_path__ + "static/media/btn_following.f24500e4.svg";